import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class App {
  async getUsageReport() {
    return (await fetchApi.get(`/report/hosted-app-usage`)).data;
  }

  async addApp(Workspace_id, postData) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/apps`, postData)).data;
  }

  async getApp(Workspace_id, App_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/apps/${App_id}`)).data;
  }

  async updateApp(Workspace_id, App_id, postData) {
    return (await fetchApi.patch(`/workspace/${Workspace_id}/apps/${App_id}`, postData)).data;
  }

  async getAppList(Workspace_id, options) {
    const { orderBy = "", order = "asc", search = "" } = options;

    return (
      await fetchApi.get(
        `/workspace/${Workspace_id}/apps?orderBy=${orderBy}&order=${order}&search=${encodeURIComponent(search)}`
      )
    ).data;
  }

  async deployApp(Workspace_id, App_id) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/apps/${App_id}/deploy`)).data;
  }

  async undeployApp(Workspace_id, App_id) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/apps/${App_id}/undeploy`)).data;
  }

  async redeployApp(Workspace_id, App_id) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/apps/${App_id}/redeploy`)).data;
  }

  async deleteApp(Workspace_id, App_id) {
    return (await fetchApi.delete(`/workspace/${Workspace_id}/apps/${App_id}`)).data;
  }

  async getHistory(Workspace_id, App_id, { orderBy, order }) {
    let paramQuery = `orderBy=${orderBy}&order=${order}`;
    return (await fetchApi.get(`/workspace/${Workspace_id}/apps/${App_id}/history?${paramQuery}`)).data;
  }

  async getDetailedHistory(Workspace_id, App_id, postData) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/apps/${App_id}/history`, postData)).data;
  }
}
